import { EstimativaComponent } from './estimativa/estimativa.component';

import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';

import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { MatStepperModule } from '@angular/material/stepper'
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { CatalogComponent } from './catalog/catalog.component';
import { CatalogDialogComponent } from './catalog-dialog/catalog-dialog.component';
import { MatTableModule } from '@angular/material/table';
import { FilterPipe } from './filter.pipe';
import { FindActionPipe } from './find-action.pipe';
import { ResultComponent } from './result/result.component';
import { ResultContainerComponent } from './result-container/result-container.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { CustomStepperComponent } from './custom-stepper/custom-stepper.component';
import { ActivityComponent } from './activity/activity.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { AcceptCommentEstimateDialog } from './accept-comment-estimate-dialog/accept-comment-estimate-dialog.component';
import { EditValueDialogComponent } from './edit-value-dialog/edit-value-dialog.component';
import { MatSliderModule } from '@angular/material/slider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { ImputacionRealComponent } from './imputacion-real/imputacion-real.component';
import { AnalisisDesviacionesComponent } from './analisis-desviaciones/analisis-desviaciones.component';
import { ClassDirective } from "@ngbracket/ngx-layout";
import { TextFieldModule } from '@angular/cdk/text-field';
import { ProfileSelectorDialogComponent } from './profile-selector-dialog/profile-selector-dialog.component';
import { ConfirmInitialCostDialogComponent } from './confirm-initial-cost-dialog/confirm-initial-cost-dialog.component';
import { AiGenerateDialogComponent } from './ai-generate-dialog/ai-generate-dialog.component';

@NgModule({
  declarations: [
    EstimativaComponent,
    CatalogComponent,
    CatalogDialogComponent,
    FilterPipe,
    FindActionPipe,
    ResultComponent,
    ResultContainerComponent,
    CustomStepperComponent,
    ActivityComponent,
    ConfirmDialogComponent,
    AcceptCommentEstimateDialog,
    EditValueDialogComponent,
    ImputacionRealComponent,
    AnalisisDesviacionesComponent,
    ProfileSelectorDialogComponent,
    ConfirmInitialCostDialogComponent,
    AiGenerateDialogComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatStepperModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatDialogModule,
    MatCheckboxModule,
    MatOptionModule,
    MatSelectModule,
    MatTableModule,
    FontAwesomeModule,
    MatTooltipModule,
    MatIconModule,
    DragDropModule,
    NgxMatSelectSearchModule,
    MatSliderModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    ClassDirective,
    TextFieldModule
  ],
  exports: [
    EstimativaComponent
  ],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false }
    }
  ],
})
export class EstimativaModule { }
